interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  invert?: boolean;
}

export default function SectionTitle({
  eyebrow,
  title,
  description,
  align = "center",
  invert = false,
}: SectionTitleProps) {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto" : "text-left"} max-w-3xl mb-12 md:mb-16`}
    >
      {eyebrow && (
        <p
          className={`text-xs tracking-[0.3em] uppercase mb-4 ${
            invert ? "text-accent-300" : "text-accent-700"
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        className={`font-heading text-3xl md:text-4xl leading-tight mb-4 ${
          invert ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`text-sm md:text-base leading-relaxed ${
            invert ? "text-background-200" : "text-foreground-700"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}